import { CartController } from "@features/accounts/hooks/useCartController"
import type { PaymentIntent, PaymentMethodCreateParams, PaymentMethodResult, StripeError } from "@stripe/stripe-js"
import { createContext, PropsWithChildren, useContext } from "react"
import { z } from "zod"
import { dynamic } from "eddev/dynamic"

const StripePayment = dynamic(() => import("./StripePayment"))

export const StripePaymentSchema = z.custom<PaymentMethodValue>((val) => (val && typeof val === "object" ? true : false), "Please select a payment method")

export type PaymentMethodValue = {
  intentId?: string
}

type Props = {
  value?: PaymentMethodValue
  onChange: (value: PaymentMethodValue) => void
}

export function StripePaymentField(props: Props) {
  return <StripePayment />
}

export type GetPaymentMethodFunction = (billingDetails: PaymentMethodCreateParams.BillingDetails) => Promise<{
  error?: string
  paymentMethodId?: string
}>

type PaymentContext = {
  publishableKey: string
  clientSecret: string | null
  onCanGetPaymenthMethod(e: { canSubmit: true; getPaymentMethod: GetPaymentMethodFunction }): void
}

const PaymentContext = createContext<PaymentContext | undefined>(undefined)

export function StripePaymentContext(props: PropsWithChildren<PaymentContext>) {
  return <PaymentContext.Provider value={props}>{props.children}</PaymentContext.Provider>
}

export function useStripePaymentContext() {
  return useContext(PaymentContext)
}
